<script setup lang="ts">
import { faClose } from '@fortawesome/pro-regular-svg-icons';

const { bottomSpace = 64 } = defineProps<{ bottomSpace?: number }>();
const bottomSpacePx = computed(() => `${bottomSpace}px`);
const authStore = useAuthStore();
const analyticsStore = useAnalyticsStore();
const { loggedIn } = storeToRefs(authStore);
const closed = ref(false);
const sessionKey = 'login-notification-closed';
const { login } = useAuth();
const searchFormStore = useSearchFormStore();
const route = useRoute();

function loginHandler() {
    analyticsStore.trackAll('sign-in-sing-up-notification-open', {
        page: route.path === '/' ? 'home' : searchFormStore.reserveType,
    });
    login();
}
function close() {
    sessionStorage.setItem(sessionKey, 'true');
    analyticsStore.trackAll('sign-in-sing-up-notification-close', {
        service: route.path === '/' ? 'home' : searchFormStore.reserveType,
    });
    closed.value = true;
}

onMounted(() => {
    closed.value = sessionStorage.getItem(sessionKey) === 'true';
});
</script>
<template>
    <ClientOnly>
        <div v-if="!loggedIn && !closed" class="container">
            <mr-button
                size="small"
                :icon-button="faClose"
                variant="transparent"
                @click="close"
            />
            <mr-typography size="x-small" weight="500" class="body">
                جهت نمایش پیشنهاد ویژه و دریافت تخفیف وارد
                <mr-typography size="x-small" type="span" weight="700">
                    حساب کاربری
                </mr-typography>
                شوید.
            </mr-typography>
            <div class="spacer" />
            <mr-button class="login" size="small" @click="loginHandler()">
                ورود یا ثبت‌نام
            </mr-button>
        </div>
    </ClientOnly>
</template>
<style scoped lang="scss">
.container {
    border: 1px solid usePalette($factor: $p-300);
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 12px;
    padding: 8px 12px;
    background-color: usePalette($factor: $p-200);
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 1200px;
    margin-inline: auto;
    z-index: 8000;
    @include mobile-only {
        bottom: v-bind(bottomSpacePx);
        width: calc(100% - 16px);
    }
    .body {
        display: inline;
        align-items: center;
    }
    .spacer {
        flex-grow: 1;
    }
    .login {
        white-space: nowrap;
        flex-shrink: 0;
    }
}
</style>
